import { Pagination } from "@mui/material"

const CustomPagination = ({ tableData, totalRows, rowsPerPage, page, handlePage }) => {
    const rangeStart = totalRows ? page * rowsPerPage + 1 : 0;
    const rangeEnd = totalRows ? Math.min((page + 1) * rowsPerPage, totalRows) : 0;

    return (
        <div className="pagination-wrap">
            <p style={{ marginBottom: Math.ceil(totalRows / rowsPerPage) > 1 ? "10px" : "0" }}>Showing {rangeStart}-{rangeEnd} of {totalRows}</p>
            <Pagination
                page={page + 1}
                count={Math.ceil(totalRows / rowsPerPage)}
                color="primary"
                boundarycount={1}
                onChange={(event, newPage) => handlePage(newPage - 1)}
            />
        </div>
    )
}

export default CustomPagination